import { countries, defaultCountry } from '../../constants/countries';

const GEOLOCATION_CODE_SEPARATOR = '_';
const CANONICAL_NAME_SEPARATOR = ',';
const REGULAR_COUNTRY_CODE_LENGTH = 2;
const DEFAULT_VALUE = '';

const geoLocationSelectHelper = {
    getGeoData: (newLocation) => {
        let country_code, geo_location;

        if (newLocation?.value?.includes(GEOLOCATION_CODE_SEPARATOR)) {
            const spliitedItems = newLocation.value.split(GEOLOCATION_CODE_SEPARATOR);

            country_code = spliitedItems[0];
            geo_location = spliitedItems[1];
        } else {
            country_code = newLocation?.value;
        }

        return { country_code, geo_location };
    },
    isGeolocationCode: (code = DEFAULT_VALUE) =>
        code.length > REGULAR_COUNTRY_CODE_LENGTH && code.includes(GEOLOCATION_CODE_SEPARATOR),
    extractRegularLocationCode: (code = DEFAULT_VALUE) =>
        code.substring(0, code.indexOf(GEOLOCATION_CODE_SEPARATOR)),
    createLocationObject: (searchPreference = null) => {
        const locationName = searchPreference?.label;

        return locationName
            ? {
                  'Canonical Name': locationName,
                  Name: locationName.substring(
                      0,
                      searchPreference?.label.indexOf(CANONICAL_NAME_SEPARATOR)
                  ),
                  label: locationName,
                  value: searchPreference?.value,
              }
            : { label: countries[defaultCountry], value: defaultCountry };
    },
};

export default geoLocationSelectHelper;
